

export const BOOKINGFLIGHT = "booking/addBookingFlight";
export const CANCELBOOKINGFLIGHT = "booking/cancelBookingFlight";

